module.exports = __webpack_public_path__ + "static/img/facias-and-guttering.2355dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/facias-and-guttering.png
// module id = XB/5
// module chunks = 1